import React, {useCallback, useRef} from 'react';
import { motion, useReducedMotion } from 'framer-motion';

import styles from './InstallAppPopup.module.scss';
import buttonClose from '../../../assets/images/button-close.png';
import installAppSteps from '../../../assets/images/InstallAppSteps.png'

import { overlayMotion, modalBoxMotionCentered } from '../../motion/modalMotion';
import useClickOutside from "../../../hooks/useClickOutside";

const InstallAppPopup = ({ deviceType, setInstallAppPopupOpen }) => {
    const isFirstRender = useRef(true);
    const reduce = useReducedMotion();

	const wrapperRef = useClickOutside(useCallback(() => {
		setInstallAppPopupOpen()
    }, []));

	const closePopup = (event) => {
		if (event.target === event.currentTarget){
			setInstallAppPopupOpen(false);
		}
	};

    return (
        <motion.div className={styles.overlay} onClick={(event) => closePopup(event)} {...overlayMotion(reduce)}>
            <motion.div className={styles.wrapper} {...modalBoxMotionCentered(reduce)}>
                <div className={styles.innerWrapper}>
                    <div className={styles.crateContains}>Add Siege: World War Il web shop to your home page</div>
					<div>
						<img src={installAppSteps} alt='img' className={styles.installSteps}></img>
					</div>
                </div>
                <img src={buttonClose} alt={'img'} className={styles.buttonClose} onClick={() => setInstallAppPopupOpen(false)} />
            </motion.div>
        </motion.div>
    );
};

export default InstallAppPopup;